import { render, staticRenderFns } from "./ManageUPI.vue?vue&type=template&id=56272a8c&"
import script from "./ManageUPI.vue?vue&type=script&lang=js&"
export * from "./ManageUPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports